export const about = {
  hero: {
    title: 'O spoločnosti',
    titleHighlight: 'BULKCOM',
    description: 'Vedieme transformáciu globálnych energetických trhov prostredníctvom inovatívnych riešení dodávateľského reťazca, strategických partnerstiev a neochvejného záväzku k prevádzkovej dokonalosti a udržateľnosti.'
  },
  purpose: {
    title: 'Náš účel',
    subtitle: 'Poháňame budúcnosť distribúcie energie',
    mission: 'Poslanie',
    missionText: 'Poskytovať spoľahlivé a nákladovo efektívne energetické riešenia, ktoré poháňajú priemyselný rast pri zachovaní najvyšších štandardov bezpečnosti, environmentálnej zodpovednosti a prevádzkovej dokonalosti.',
    vision: 'Vízia pre rok 2030',
    visionText: 'Byť najdôveryhodnejším energetickým partnerom v Európe, uznávaným za inovácie v optimalizácii dodávateľského reťazca, záväzok k uhlíkovej neutralite a výnimočné služby klientom.',
    values: 'Základné hodnoty',
    valuesText: 'Integrita, bezpečnosť, inovácie, udržateľnosť a partnerstvo vedú každé naše rozhodnutie a každý vzťah, ktorý budujeme.'
  },
  benefits: {
    title: 'Prečo si vybrať BULKCOM',
    subtitle: 'Konkurenčné výhody, ktoré nás odlišujú',
    globalNetwork: 'Globálna sieť',
    globalNetworkDesc: 'Strategické partnerstvá vo viac ako 50 krajinách zabezpečujúce bezpečnosť dodávok a konkurenčné ceny',
    expertise: '15+ rokov skúseností',
    expertiseDesc: 'Hlboké znalosti odvetvia a overené výsledky na komplexných energetických trhoch',
    technology: 'Pokročilá technológia',
    technologyDesc: 'Najmodernejšie SCADA systémy a monitorovanie v reálnom čase pre optimálny výkon',
    compliance: '100% súlad',
    complianceDesc: 'Plné dodržiavanie predpisov a priemyselné certifikácie na všetkých trhoch',
    support: 'Podpora 24/7',
    supportDesc: 'Dedikované operačné centrum poskytujúce nepretržité monitorovanie a rýchlu reakciu',
    sustainability: 'ESG záväzok',
    sustainabilityDesc: 'Aktívne programy znižovania uhlíka a investície do prechodu na obnoviteľnú energiu'
  },
  partnership: {
    title: 'Prístup k partnerstvu',
    subtitle: 'Budovanie dlhodobých vzťahov založených na dôvere a vzájomnom úspechu',
    consultation: 'Konzultácia',
    consultationDesc: 'Hĺbková analýza vašich energetických požiadaviek a prevádzkových obmedzení',
    solution: 'Návrh riešenia',
    solutionDesc: 'Vlastná stratégia dodávky energie zosúladená s vašimi obchodnými cieľmi',
    implementation: 'Implementácia',
    implementationDesc: 'Bezproblémová integrácia s vašou existujúcou infraštruktúrou a procesmi',
    optimization: 'Optimalizácia',
    optimizationDesc: 'Nepretržité monitorovanie a úpravy na maximalizáciu efektívnosti a hodnoty',
    cta: 'Začnite partnerstvo',
    ctaDesc: 'Spojte sa s naším tímom a preskúmajte, ako môžeme podporiť vaše energetické potreby'
  }
};
